"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H1"));

var _H2 = _interopRequireDefault(require("UIComponents/elements/headings/H5"));

var _colors = require("HubStyleTokens/colors");

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _Breakpoints = require("pricing-pages-unified-ui/constants/Breakpoints");

var _GuaranteeBlob = _interopRequireDefault(require("./GuaranteeBlob"));

var _SignupButton = _interopRequireDefault(require("pricing-pages-unified-ui/components/public-only/SignupButton"));

var _EnvironmentWrapper = _interopRequireDefault(require("pricing-pages-unified-ui/components/EnvironmentWrapper"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _LoadingStateSelectors = require("../../selectors/LoadingStateSelectors");

var _SkeletonLoadWrapper = _interopRequireDefault(require("../loading/SkeletonLoadWrapper"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    height: auto;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Guarantee = (0, _styledComponents.default)(function (_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      header = _ref.header,
      body = _ref.body;
  return _react.default.createElement("div", {
    className: className
  }, _react.default.createElement("div", null, _react.default.createElement(_UIIcon.default, {
    name: icon,
    color: _colors.FLINT,
    size: "medium",
    className: "m-bottom-2"
  })), _react.default.createElement("div", null, _react.default.createElement(_H2.default, null, header)), _react.default.createElement("div", null, body));
}).withConfig({
  displayName: "GuaranteeSection__Guarantee",
  componentId: "gcinwp-0"
})(["width:240px;text-align:center;@media (max-width:", "px){&:not(:last-child){margin-bottom:10px;}}"], _Breakpoints.GUARANTEE_SECTION);

var GuaranteeRow = _styledComponents.default.div.withConfig({
  displayName: "GuaranteeSection__GuaranteeRow",
  componentId: "gcinwp-1"
})(["display:flex;justify-content:space-between;flex-wrap:nowrap;margin-bottom:24px;width:100%;max-width:870px;@media (max-width:", "px){flex-direction:column;align-items:center;}"], _Breakpoints.GUARANTEE_SECTION);

var GuaranteeSection = (0, _styledComponents.default)(function (_ref2) {
  var className = _ref2.className;
  var hasPricingAndPurchasingSucceeded = (0, _reactRedux.useSelector)(_LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector);
  return _react.default.createElement("div", {
    className: className
  }, _react.default.createElement(_GuaranteeBlob.default, null), _react.default.createElement(_H.default, {
    className: "m-bottom-12 text-center"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricingPage.pages.crm.guarantee"
  })), _react.default.createElement(GuaranteeRow, null, _react.default.createElement(Guarantee, {
    icon: "lists",
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.unlimitedHeader"
    }),
    body: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.unlimitedBody"
    })
  }), _react.default.createElement(Guarantee, {
    icon: "tag",
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.freeHeader"
    }),
    body: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.freeBody"
    })
  }), _react.default.createElement(Guarantee, {
    icon: "generateChart",
    header: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.dataHeader"
    }),
    body: _react.default.createElement(_FormattedMessage.default, {
      message: "pricingPage.pages.crm.dataBody"
    })
  })), _react.default.createElement(_EnvironmentWrapper.default, {
    publicNode: _react.default.createElement(_SkeletonLoadWrapper.default, {
      isLoading: !hasPricingAndPurchasingSucceeded,
      widths: [200],
      heights: [56]
    }, _react.default.createElement(_SignupButton.default, {
      sourceId: "crm-pricing-middle",
      className: "p-x-9 p-y-5 m-top-5",
      ctaKey: "pricingPage.signupCtas.getStartedFree"
    }))
  }));
}).withConfig({
  displayName: "GuaranteeSection",
  componentId: "gcinwp-2"
})(["display:flex;text-align:center;flex-direction:column;align-items:center;margin-top:80px;margin-bottom:30px;padding:40px 16px;width:100%;position:relative;z-index:1;@media (max-width:", "px){background-color:", ";margin-top:40px;margin-bottom:0;padding-bottom:2.1em;}", ";"], _Breakpoints.GUARANTEE_SECTION, _colors.GYPSUM, _responsiveBreakpoints.default.tablet(_templateObject()));
var _default = GuaranteeSection;
exports.default = _default;
module.exports = exports.default;